import { combineReducers } from "redux";
import certificaciones from './cms.reducer';

const reducer = combineReducers({    
    certificaciones
});

export default reducer;